import firebase from 'firebase'
const Rebase = require('re-base');

firebase.initializeApp({
  apiKey: "AIzaSyBOiUW0l4M0x8grw6f6_TuloCnmP64yOa8",
  authDomain: "oncallogy-177220.firebaseapp.com",
  databaseURL: "https://oncallogy-177220.firebaseio.com",
  storageBucket: "oncallogy-177220.appspot.com",
  messagingSenderId: "527543976870"
});

const base = Rebase.createClass(firebase.database());
export default base

export const db = firebase.database()
export const firebaseAuth = firebase.auth

export const loginWithToken = token => 
  firebase.auth().signInWithCustomToken(token)



// WEBPACK FOOTER //
// ./src/config/firebase.js